@if (title) {
  <ng-container header>{{title}}</ng-container>
}
<form [formGroup]="form">
  <rask-kundorderrad-mottagningsplatser
    [alternativaMottagningsplatser]="model.alternativaMottagningsplatser"
    [newMode]="isNew"
    [showLabels]="showLabels"
    [ngClass]="getClass(2)"
    [form]="form"
    [typ]="kundorderTyp"
    [validation]="validation"
    [readonly]="isCopy">
  </rask-kundorderrad-mottagningsplatser>
  <rask-multi-selector
    label="{{'KUNDORDER_DETAIL_AVLASTNINGSPLATS' | translate}}"
    aid="inputLagerplatser"
    [itemDisabled]="lagerplatsDisabled"
    [viewFormatter]="lagerplatserViewFormatter"
    formControlName="lagerplatser"
    [ngClass]="getClass(1, 3)"
    [items]="lagerplatser"
    [viewSelectedFormatter]="lagerplatserViewSelectedFormatter"
    bindLabel="kod"
    [rule]="validation.lagerplats"
    [raskDisabledControl]="isCopy">
  </rask-multi-selector>
  <rask-kundorderrad-handelssortiment
    [alternativaHandelssortiment]="model.alternativaHandelssortiment"
    [inmatningshandelssortiment]="model.inmatningshandelssortiment"
    [beraknatInmatningshandelssortiment]="model.beraknatInmatningshandelssortiment"
    [newMode]="isNew"
    [showLabels]="showLabels"
    [ngClass]="getClass(2, 5)"
    [form]="form"
    [validation]="validation"
    [kundorderradId]="model.id"
    [kundorderrad]="model"
    [readonly]="isCopy">
  </rask-kundorderrad-handelssortiment>
  <rask-input-number
    label="{{'KUNDORDER_DETAIL_KVANTITET' | translate}}"
    aid="inputKvantitet"
    style="width:160px;max-width:none;"
    [ngClass]="getClass(1, 2)"
    [required]="true"
    [rule]="validation.kvantitet"
    unit="{{mattslag}}"
    formControlName="kvantitet"
    [raskDisabledControl]="isCopy"
    [min]="0">
  </rask-input-number>
  <rask-datepicker
    aid="inputPeriodFrom"
    style="width:160px;max-width:none;"
    [required]="true"
    label="{{'KUNDORDER_DETAIL_FROM' | translate}}"
    [rule]="validation.periodFrom"
    formControlName="periodFrom"
    [ngClass]="getClass(1)"
    [minDate]=""
    [raskDisabledControl]="isCopy">
  </rask-datepicker>
  <rask-datepicker
    label="{{'KUNDORDER_DETAIL_TOM' | translate}}"
    aid="inputPeriodTom"
    style="width:160px;max-width:none;"
    [required]="true"
    [rule]="validation.periodTom"
    formControlName="periodTom"
    [minDate]="model.periodFrom"
    [ngClass]="getClass(1)"
    [raskDisabledControl]="isCopy">
  </rask-datepicker>
  @if (!isNew && !isCopy) {
    <rask-input
      class="col-lg-1 low"
      [ngClass]="{'negative': balans < 0}"
      [value]="balans | number"
      [readonly]="true">
    </rask-input>
  }
  @if (isCopy) {
    <rask-checkbox [ngClass]="getClass(1)" text="Kopiera med" formControlName="kopiera"></rask-checkbox>
  }
  @if (!isNew && !isCopy) {
    <div class="d-inline" [ngClass]="getClass(1)">
      <rask-menu-button [template]="tpl" #menu></rask-menu-button>
      <rask-icon-button
        class="kundorderrad-comment"
        (click)="openComment()"
        ngbTooltip="{{model.kommentar?.length ? 'Kommentar finns, klicka för att läsa eller editera.' : 'Ingen kommentar finns, klicka för att editera.'}}"
        container="body"
        icon="{{model.kommentar?.length ? 'fa-solid' : 'fa-regular'}} fa-comment">
      </rask-icon-button>
    </div>
  }
  <ng-template #tpl>
    <div class="menu-btn-container">
      @if (!isNew) {
        <rask-action-button
          class="col-12"
          icon="far fa-sync-alt"
          aid="buttonLrUppdatera"
          [disabled]="!dateSpanChanged"
        (click)="updateLeveransrader()">Uppdatera</rask-action-button>
      }
      @if (!isNew) {
        <rask-action-button
          class="col-12"
          aid="buttonLrTabort"
          color="tertiary"
          icon="far fa-trash-alt fa-lg"
          (click)="delete()"
          [disabled]="!canEdit() || kundorder.kundorderrader.length === 1"
        negative>Ta bort</rask-action-button>
      }
      @if (!isNew) {
        <rask-action-button
          class="col-12"
          aid="buttonLrFordela"
          color="secondary"
          icon="far fa-sync-alt"
          (click)="fordelaLeveransrad()"
          [disabled]="form.controls.kvantitet.pristine"
        negative>Uppdatera kvantitet</rask-action-button>
      }
    </div>
  </ng-template>
  <div class="row row-margin-fix">
    @if (!isCreate) {
      <div class="col-5 no-height"></div>
    }
    <rask-checkbox
      aid="checkboxManuellPaAo"
      class="row-checkbox"
      formControlName="manuellPaArbetsorder"
      [ngClass]="getClass(1, 2, 'checkbox-padding')"
      text="{{ 'KUNDORDER_DETAIL_MANUELLPAAO' | translate }}"
      [rule]="validation.manuellPaAo"
      [raskDisabledControl]="isCopy">
    </rask-checkbox>
    <rask-checkbox
      aid="checkboxEgenskapskodX"
      class="row-checkbox"
      [ngClass]="getClass(1, 2)"
      formControlName="egenskapskodX"
      text="{{ 'KUNDORDER_DETAIL_EGENSKAPSKODX' | translate }}"
      [rule]="validation.egenskapskodX"
      [raskDisabledControl]="isCopy">
    </rask-checkbox>
    @if (kundorderTyp === 'TERMINAL' || kundorderTyp === 'KUND') {
      <rask-checkbox
        aid="checkboxEjVirkeskop"
        class="row-checkbox"
        [ngClass]="getClass(1, 3)"
        formControlName="ejVirkeskop"
        text="{{ 'KUNDORDER_DETAIL_EJVIRKESKOP' | translate }}"
        [raskDisabledControl]="isCopy">
      </rask-checkbox>
    }
  </div>
</form>
